const cap = {
  areas: [
    {
      id: 1,
      slug: 'visor',
      name: 'バイザー'
    },
    {
      id: 2,
      slug: 'crown',
      name: 'クラウン'
    },
    {
      id: 3,
      slug: 'mark',
      name: 'マーク'
    }
  ],
  parts: [
    {
      id: 1,
      slug: 'visor_form',
      name: '形',
      area_id: 1,
    },
    {
      id: 2,
      slug: 'visor_line',
      name: 'バイザーライン',
      area_id: 1,
    },
    {
      id: 3,
      slug: 'crown_front',
      name: '正面',
      area_id: 2,
    },
    {
      id: 4,
      slug: 'crown_back',
      name: 'サイドバック',
      area_id: 2,
    },
    {
      id: 5,
      slug: 'crown_hole',
      name: '穴がかり',
      area_id: 2,
    },
    {
      id: 6,
      slug: 'crown_button',
      name: '天ボタン',
      area_id: 2,
    }
  ],
  items: {
    visor_form: [
      {
        id: 1,
        slug: 'visor_form_arch',
        name: 'アーチ',
      },
      {
        id: 2,
        slug: 'visor_form_flat',
        name: '平つば',
      },
    ],
    visor_line: [
      {
        id: 1,
        slug: 'visor_line_off',
        name: 'なし',
      },
      {
        id: 2,
        slug: 'visor_line_on',
        name: 'あり',
      },
    ],
    mark: [
      {
        id: 1,
        slug: 'mark_1',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 2,
        slug: 'mark_2',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 3,
        slug: 'mark_3',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 4,
        slug: 'mark_4',
        background_color: '#00256A',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 5,
        slug: 'mark_5',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 6,
        slug: 'mark_6',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 7,
        slug: 'mark_7',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 8,
        slug: 'mark_8',
        background_color: '#00031F',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 9,
        slug: 'mark_9',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 10,
        slug: 'mark_10',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 11,
        slug: 'mark_11',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 12,
        slug: 'mark_12',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 13,
        slug: 'mark_13',
        background_color: '#777568',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 14,
        slug: 'mark_14',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 15,
        slug: 'mark_15',
        background_color: '#006528',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 16,
        slug: 'mark_16',
        background_color: '#00256A',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 17,
        slug: 'mark_17',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 18,
        slug: 'mark_18',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 19,
        slug: 'mark_19',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 20,
        slug: 'mark_20',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 21,
        slug: 'mark_21',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 22,
        slug: 'mark_22',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 23,
        slug: 'mark_23',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 24,
        slug: 'mark_24',
        background_color: '#00256A',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 25,
        slug: 'mark_25',
        background_color: '#636360',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 26,
        slug: 'mark_26',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 27,
        slug: 'mark_27',
        background_color: '#636360',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 28,
        slug: 'mark_28',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 29,
        slug: 'mark_29',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 30,
        slug: 'mark_30',
        color1: true,
        color2: true,
        color3: true,
      },
      {
        id: 31,
        slug: 'mark_31',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 32,
        slug: 'mark_32',
        background_color: '#00031F',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 33,
        slug: 'mark_33',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 34,
        slug: 'mark_34',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 35,
        slug: 'mark_35',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 36,
        slug: 'mark_36',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 37,
        slug: 'mark_37',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 38,
        slug: 'mark_38',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 39,
        slug: 'mark_39',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 40,
        slug: 'mark_40',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 41,
        slug: 'mark_41',
        background_color: '#BF001E',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 42,
        slug: 'mark_42',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 43,
        slug: 'mark_43',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 44,
        slug: 'mark_44',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 45,
        slug: 'mark_45',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 46,
        slug: 'mark_46',
        color1: true,
        color2: false,
        color3: false,
      },
      {
        id: 47,
        slug: 'mark_47',
        background_color: '#00966C',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 48,
        slug: 'mark_48',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 49,
        slug: 'mark_49',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 50,
        slug: 'mark_50',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 51,
        slug: 'mark_51',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 52,
        slug: 'mark_52',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 53,
        slug: 'mark_53',
        color1: true,
        color2: true,
        color3: false,
      },
      {
        id: 54,
        slug: 'mark_54',
        color1: true,
        color2: false,
        color3: false,
      },
    ]
  }
}
export default cap
  